// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rDaZ","top":"styles_top__9y3lo","left":"styles_left__2h-9h","description":"styles_description__l8JWF"};